import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-provider';
var genProStyle = function genProStyle(token) {
  var _token$componentCls2, _ref;
  return _ref = {}, _defineProperty(_ref, "".concat(token.antCls, "-pro"), _defineProperty({}, "".concat(token.antCls, "-form:not(").concat(token.antCls, "-form-horizontal)"), _defineProperty({}, token.componentCls, _defineProperty({}, "&-item:not(".concat(token.componentCls, "-item-show-label)"), _defineProperty({}, "".concat(token.antCls, "-form-item-label"), {
    display: 'none'
  }))))), _defineProperty(_ref, token.componentCls, (_token$componentCls2 = {
    maxWidth: '100%',
    '&-item': {
      '&&-show-label': _defineProperty({}, "".concat(token.antCls, "-form-item-label"), {
        display: 'inline-block'
      }),
      '&:first-of-type': {
        'div:first-of-type': _defineProperty({}, "".concat(token.antCls, "-form-item"), _defineProperty({}, "".concat(token.antCls, "-form-item-label"), {
          display: 'inline-block'
        }))
      }
    },
    '&-action': {
      display: 'flex',
      height: '32px',
      marginBlockEnd: '24px',
      lineHeight: '32px'
    },
    '&-action-icon': {
      marginInlineStart: 8,
      cursor: 'pointer',
      transition: 'color 0.3s ease-in-out',
      '&:hover': {
        color: token.colorPrimaryTextHover
      }
    }
  }, _defineProperty(_token$componentCls2, "".concat(token.proComponentsCls, "-card ").concat(token.proComponentsCls, "-card-extra"), _defineProperty({}, token.componentCls, {
    '&-action': {
      marginBlockEnd: 0
    }
  })), _defineProperty(_token$componentCls2, '&-creator-button-top', {
    marginBlockEnd: 24
  }), _token$componentCls2)), _ref;
};
export function useStyle(prefixCls) {
  return useAntdStyle('ProFormList', function (token) {
    var proToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });
    return [genProStyle(proToken)];
  });
}